import React, { Component } from "react";
import { Text } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import TldrChakraSlider from "../../common/TldrChakraSlider";

class TLDRDownloadGIFSpeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gifSpeed: 1,
    };
  }

  render() {
    let { gifSpeed } = this.props;
    const { t } = this.props;
    return (
      <>
        <Text fontSize="xs" casing="uppercase" mb={2} mt={2}>
          {t("gif_speed")}
        </Text>
        <TldrChakraSlider
          domain={[0.5, 3]}
          onChange={this.onChange}
          values={gifSpeed}
          showDecimals={true}
          step={0.1}
          unit="x"
          variant="solid"
        />
      </>
    );
  }

  onChange = (value) => {
    this.props.onGIFSpeedChange(value);
    this.setState({
      gifSpeed: value,
    });
  };
}

TLDRDownloadGIFSpeed.propTypes = {};

export default withTranslation(["navbar"])(TLDRDownloadGIFSpeed);
